import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndigenousCloudRoutingModule } from './indigenous-cloud-routing.module';
import { ICHomeComponent } from './ic-home/ic-home.component';
import { CoreModule } from 'src/app/core/core.module';
import { IcHeaderComponent, UpdatePaymentDialog } from './ic-header/ic-header.component';
import { IcFooterComponent } from './ic-footer/ic-footer.component';
import { IcFooterV2Component } from './ic-footer-v2/ic-footer-v2.component';
import { IcFooterSchoolsComponent } from './ic-footer-v2/ic-footer-schools/ic-footer-schools.component';
import { IcMainComponent } from './ic-main/ic-main.component';
import { GenerListComponent } from './gener-list/gener-list.component';
import { AlbumListComponent, IOSModalDialog } from './album-list/album-list.component';
import { VideoDetailV2Component } from './video-detail-v2/video-detail-v2.component';
import { VdVideoRowComponent } from './video-detail-v2/vd-video-row/vd-video-row.component';
import { VdTrackPricePipe } from './video-detail-v2/video-detail-price';
import { VdPlayerComponent } from './video-detail-v2/vd-player/vd-player.component';
import { VdPlayerControlsComponent } from './video-detail-v2/vd-player/vd-player-controls.component';
import { VdSidePanelComponent } from './video-detail-v2/vd-side-panel/vd-side-panel.component';
import { VdCommentsComponent } from './video-detail-v2/vd-comments/vd-comments.component';
import { VdInfoComponent } from './video-detail-v2/vd-info/vd-info.component';
import { VdRecsComponent } from './video-detail-v2/vd-recs/vd-recs.component';
import { VdIconComponent } from './video-detail-v2/vd-icon/vd-icon.component';
import { VdThumbComponent } from './video-detail-v2/vd-thumb/vd-thumb.component';
import { VdShareSheetComponent } from './video-detail-v2/vd-share-sheet/vd-share-sheet.component';
import { IcSearchComponent } from './ic-search/ic-search.component';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { MusicPlayerComponent } from './music-player/music-player.component';
import { AddPlaylistComponent } from './add-playlist/add-playlist.component';
import { PlaylistComponent } from './playlist/playlist.component';
import { IcMediaPaymentComponent } from './ic-media-payment/ic-media-payment.component';
import { PlaylistDetailsComponent } from './playlist-details/playlist-details.component';
import { IcContactusComponent } from './ic-contactus/ic-contactus.component';
import { GeneralModule } from '../general/general.module';
import { MatMenuModule } from '@angular/material/menu';
import { Title } from '@angular/platform-browser';
import { CommunityComponent } from './community/community/community.component';
import { CommunitySidenavComponent } from './community/community-sidenav/community-sidenav.component';
import { CommunityMaincontentComponent } from './community/community-maincontent/community-maincontent.component';
import { AddChannelCommunityDialogComponent } from './community/add-channel-community-dialog/add-channel-community-dialog.component';
import { ChannelDefaultPageComponent } from './community/channel-default-page/channel-default-page.component';
import { CommunityTipsComponent } from './community/community-tips/community-tips.component';
import { VideoPlayerPageComponent } from './video-player-page/video-player-page.component';
import { MercheMarketplaceModule } from '../merche-marketplace/merche-marketplace.module';
import { EventNavigationModule } from '../event-navigation/event-navigation.module';
import { FastMultichannelComponent } from './storm-player/storm-player.component';
import { CommunityV2Module } from './community-v2/community-v2.module';
import { IcTopMenuComponent } from './ic-top-menu/ic-top-menu.component';
import { IcSearchSuggestionsComponent } from './ic-top-menu/ic-search-suggestions/ic-search-suggestions.component';
import { LogoTileDirective } from 'src/app/core/directives/logo-tile/logo-tile.directive';


@NgModule({
  declarations: [
    ICHomeComponent,
    IcHeaderComponent,
    IcFooterComponent,
    IcFooterV2Component,
    IcFooterSchoolsComponent,
    IcMainComponent,
    GenerListComponent,
    AlbumListComponent,
    VideoDetailV2Component,
    VdVideoRowComponent,
    VdTrackPricePipe,
    VdPlayerComponent,
    VdPlayerControlsComponent,
    VdSidePanelComponent,
    VdCommentsComponent,
    VdInfoComponent,
    VdRecsComponent,
    VdIconComponent,
    VdThumbComponent,
    VdShareSheetComponent,
    IcSearchComponent,
    MusicPlayerComponent,
    AddPlaylistComponent,
    PlaylistComponent,
    IcMediaPaymentComponent,
    PlaylistDetailsComponent,
    IcContactusComponent,
    IOSModalDialog,
    UpdatePaymentDialog,
    CommunityComponent,
    CommunitySidenavComponent,
    CommunityMaincontentComponent,
    AddChannelCommunityDialogComponent,
    ChannelDefaultPageComponent,
    CommunityTipsComponent,
    VideoPlayerPageComponent,
    FastMultichannelComponent,
    IcTopMenuComponent,
    IcSearchSuggestionsComponent
  ],
  imports: [
    LogoTileDirective,
    CommonModule,
    IndigenousCloudRoutingModule,
    MercheMarketplaceModule,
    CoreModule,
    ModalModule.forRoot(),
    GeneralModule,
    MatMenuModule,
    EventNavigationModule,
    CommunityV2Module,
  ],
  providers: [
    BsModalService, Title,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [MusicPlayerComponent]
})
export class IndigenousCloudModule { }
